export default __webpack_public_path__ + "static/media/DSC_0553.c0dd5ac2.webp";